import React, { useState } from 'react'
import { Button } from '../../lib/ui/button'
import { apiPost } from '~/util/api'

const NewPostLandingEvent = ({
  candidateId,
  onSuccess,
  isSaving,
  setIsSaving,
  toast,
}) => {
  const [step, setStep] = useState(1)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setIsSaving(true)
    try {
      await apiPost(`/coach/candidates/${candidateId}/post_landing`, {
        post_landing: { begin_support: true },
      })
      setIsSaving(false)
      toast &&
        toast({
          title: 'Post-Landing Support Started',
          description: 'Post-landing support has been initiated.',
          status: 'success',
        })
      onSuccess && onSuccess()
    } catch (error) {
      setIsSaving(false)
      const description =
        error?.response?.data?.error ||
        'An error occurred while starting post-landing support.'
      toast &&
        toast({
          description,
          title: 'Could Not Start Post-Landing Support',
          variant: 'destructive',
          duration: 10_000,
        })
    }
  }

  return (
    <div>
      {step === 1 && (
        <div>
          <p className="my-4 text-center">
            Have you verified that this Candidate has already made a successful
            career transition?
          </p>
          <div className="flex justify-end">
            <Button className="state1" onClick={() => setStep(2)}>
              Yes, continue
            </Button>
          </div>
        </div>
      )}
      {step === 2 && (
        <div>
          <p className="my-4 text-center">
            Click on the appropriate action below.
          </p>
          <form onSubmit={handleSubmit}>
            <input type="hidden" name="begin_support" value="true" />
            <div className="flex justify-end">
              <Button
                type="submit"
                className="btn btn-primary"
                disabled={isSaving}
              >
                {isSaving ? 'Saving...' : 'Begin Post-Landing Support'}
              </Button>
            </div>
          </form>
        </div>
      )}
    </div>
  )
}

export default NewPostLandingEvent
